import * as StringType from "./StringType"

export let InstantSchema = StringType.schema<"Instant">()
export type Instant = StringType.infer<typeof InstantSchema>

export function mkInstantDate(date: Date): Instant {
  return InstantSchema.parse(date.toISOString())
}
